module.exports = __webpack_public_path__ + "assets/img/37_1541.807c0b80.jpg";